module.exports = __webpack_public_path__ + "static/img/gaozhonglishi.c0df852b.jpg";